import { TranslationType } from "../types";
import { dashboard } from "./sl/dashboard";
import { landing } from "./sl/landing";
import { story } from "./sl/story";
import { common } from "./sl/common";
import { settings } from "./sl/settings";
import { auth } from "./sl/auth";
import { navigation } from "./sl/navigation";
import { profile } from "./sl/profile";
import { errors } from "./sl/errors";

export const sl: TranslationType = {
  ...dashboard,
  ...landing,
  ...story,
  ...common,
  ...settings,
  ...auth,
  ...navigation,
  ...profile,
  ...errors
};
